module.exports = __webpack_public_path__ + "img/2.6bdfbd70.jpg";